import { Box, Button, CircularProgress, FormControl, Typography } from "@mui/material";
import { returnValueIfTypeOfString } from "@utils/returnValueIfTypeOfString";
import { ChatTextField } from "@components/ChatTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import palette from "@styles/palette";
import { object, string } from "yup";

const loginSchema = object({
  email: string().email("Please enter a valid email.").required("Please enter your email."),
});

export function LoginFormV2({
  onSave,
  type,
}: {
  onSave: (values: any) => Promise<void>;
  type: "login" | "signup";
}): JSX.Element | null {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting, errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  return (
    <FormControl fullWidth>
      <form onSubmit={handleSubmit(onSave)}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            flexDirection: "column",
            gap: 40,
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              flexDirection: "column",
              gap: 5,
            }}
          >
            <Typography
              variant="appPageTitle"
              textAlign={"center"}
            >
              Welcome to Astronaut
            </Typography>
            <Typography
              variant="appBodyText"
              textAlign={"center"}
            >
              Please enter your company email below to continue
            </Typography>
          </Box>
          <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
            <ChatTextField
              label="Email address:"
              register={register("email")}
              defaultValue={undefined}
              placeholder="Enter your email address"
            />
            <Typography
              variant="appCaption"
              color={palette.brand.neutral.darkGray}
            >
              We&apos;ll email you a link to login
            </Typography>
            {errors?.email?.message && (
              <Typography variant="formError">
                {returnValueIfTypeOfString(errors?.email?.message)}
              </Typography>
            )}
          </Box>
          <Button
            type="submit"
            variant="primary"
            sx={{
              width: "100%",
              background: palette.brand.pink2.default,
              borderColor: palette.brand.pink2.default,
              "&:hover": {
                background: palette.brand.pink2.hover,
                borderColor: palette.brand.pink2.hover,
              },
            }}
          >
            {isSubmitting ? (
              <CircularProgress
                size={18}
                style={{ height: "100%", color: "white" }}
              />
            ) : (
              "Continue"
            )}
          </Button>
        </Box>
      </form>
    </FormControl>
  );
}
